module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/user-coupons/user-coupons.component.scss
// module id = ./src/app/admin/user-coupons/user-coupons.component.scss
// module chunks = main